import './Product.css';
import { useEffect, useState} from "react";
import { faCheck, faHeart, faShare, faStar, faTruck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import no_comment from '../images/no_comment.svg'
import icon9 from "../Icons/Icon-09.png";
import img2 from "../images/IMG-20240723-WA0008.jpg";
import img3 from "../images/IMG-20240723-WA0013.jpg";
import img4 from "../images/IMG-20240723-WA0018.jpg";
import img5 from "../images/IMG-20240723-WA0021.jpg";
import img6 from "../images/IMG-20240723-WA0022.jpg";
import { searsh_product } from "../Redux/HomeSlice";
import { useRef } from 'react';
import { product_reviews, postReviews, post_cart, show_brand, show_Influencer, show_store, product_details,
    favorites,
    addFavorite,
    remove_favorites,
    filter_data,
    sort_data
 } from '../Redux/API';
import { showRegister } from "../Redux/HomeSlice";
import Register from '../Register/Register';
import Loader from "../Loader";
import { useNavigate } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useLocation } from 'react-router-dom';
import Searsh from '../Searsh/Searsh';

import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    LinkedinShareButton,
    PinterestShareButton,
    TelegramShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    LinkedinIcon,
    PinterestIcon,
    TelegramIcon,
} from 'react-share';
import StarRatings from 'react-star-ratings';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

function Product() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const product_influencer = useSelector((state) => state.Data.show_Influencer);
    const product_store = useSelector((state) => state.Data.show_store);
    const product_brand = useSelector((state) => state.Data.show_brand);

    const product_detail = useSelector(state => state.Data.product_details);
    const product = product_detail?.data?.data?.product;

    const quantity = product?.product_varients?.[0]?.quantity || 0;
    const product_review = useSelector(state => state?.Data?.product_reviews);
    const rating = product_review?.data?.data?.reviews_avg;
    const ratings = product_review?.data?.data?.ratings;


    const [selectedItem, setSelectedItem] = useState(null);

    const [activ, setActiv] = useState(0);
    const [counter, setCounter] = useState(1);
    const [errorMessage, setErrorMessage] = useState('');

    const getLocalStorage = window.localStorage.getItem('UserInfo');
    const valueLocalStorage = getLocalStorage ? JSON.parse(getLocalStorage) : null;
    const token = valueLocalStorage?.data?.token || valueLocalStorage?.data?.data?.user?.token  || null;
  
    const showR = useSelector(state => state?.products?.showR);



    useEffect(() => {
    const id = localStorage.getItem("Product_id");
    console.log(id)
    dispatch(product_details(id));
  }, [dispatch]);


  

    const loadingPost_cart = useSelector(state => state.Data.loadingPost_cart);
    const Post_carts = useSelector(state => state.Data.post_cart);

    function handelImgeClik(image, index) {
        setSelectedItem(image);
        setActiv(index);
    
    }



const [selectedColor, setSelectedColor] = useState(null);
const [selectedSize, setSelectedSize] = useState(null);

const toggleColorSelection = (colorId) => {
    setSelectedColor(prevColor => (prevColor === colorId ? null : colorId));
};

const toggleSizeSelection = (sizeId) => {
    setSelectedSize(prevSize => (prevSize === sizeId ? null : sizeId));
};

useEffect(() => {
    if (product?.colors?.length > 0) {
        setSelectedColor(product.colors[0]?.id); // أول لون
    }
    if (product?.sizes?.length > 0) {
        setSelectedSize(product.sizes[0]?.id); // أول حجم
    }
}, [product]); // يتم التشغيل عند تحميل المنتج



    const increment = () => {
        setCounter(prevCounter => (prevCounter < quantity ? prevCounter + 1 : prevCounter));
    };

    const decrement = () => {
        setCounter(prevCounter => (prevCounter > 1 ? prevCounter - 1 : 0));
    };



    const handleAddToBasket = () => {
        if (!selectedColor) {
            setErrorMessage(t('selectColor'));
            return;
        }
    
        if (!selectedSize) {
            setErrorMessage(t('selectSize'));
            return;
        }
    
        if (counter === 0) {
            setErrorMessage(t('selectQuantity'));
            return;
        }
    
        if (token) {
            dispatch(post_cart({
                id: product.id,
                color_image_id: selectedColor,
                size_id: selectedSize,  
                quantity: counter
            }));
        } else {
            dispatch(showRegister(true));
        }
    };

    const gotoBuyNow = () => {

        // التحقق من اختيار لون
        if (!selectedColor) {
            setErrorMessage(t('selectColor'));
            return;
        }
    
        // التحقق من اختيار المقاس
        if (!selectedSize) {
            setErrorMessage(t('selectSize'));
            return;
        }
    
        // التحقق من اختيار الكمية
        if (counter === 0) {
            setErrorMessage(t('selectQuantity'));
            return;
        }
    
        if (token) {
            dispatch(post_cart({
                id: product.id,
                color_image_id: selectedColor,
                size_id: selectedSize,  
                quantity: counter
            }));
        } else {
            dispatch(showRegister(true));
        }
        navigate("/Purchasing");
        window.scrollTo(0, 0);
    };

    const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
    const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);
    const loadingAddFavorite = useSelector((state) => state.Data.loadingAddFavorite)
    const loadingProduct_details = useSelector((state) => state.Data.loadingProduct_details)
  
    useEffect(() => {
      if (!loadingAddFavorite && !loadingRemove_favorites) {
        dispatch(favorites()); 
      }
    }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);
  
    const handelAdd_wishlist = (id, event) => {
      if (token) {
        const isInWishlist = favorite?.some((item) => item.product_id === id);
        if (isInWishlist) {
          dispatch(remove_favorites(id));
        } else {
          dispatch(addFavorite({ id }));
        }
      } else {
        const { pageY } = event;
        const offsetY = -100;
        setPopupPosition({ x: 50, y: pageY + offsetY }); 
        dispatch(showRegister(true));
      }
    };




    const loadingProduct_reviews = useSelector(state => state.Data.loadingProduct_reviews);
    const loadingPostReviews = useSelector(state => state.Data.loadingPostReviews);
    const [showRating, setShowRating] = useState(false);

    const FshowRating = () => {
        setShowRating(!showRating);
    }

    const [rat, setRat] = useState(0);

    const changeRating = async (newRating) => {
        setRat(newRating);
        setTimeout(() => setShowRating(false), 5000);
        const result = await dispatch(postReviews({ product_id: product?.id, rating: newRating }));

        if (result?.payload?.status === 200) {
            setShowRating(!showRating); 
        } else {
            console.error("Failed to submit review.");
        }
    };

    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

    const Sign_Up = (event) => {
        if (!token) {
            const { pageY } = event;
            const offsetY = -1200;
            setPopupPosition({ x: 50, y: pageY + offsetY });
          dispatch(showRegister(true));
        }
    };

      useEffect(() => {
        const id = localStorage.getItem("Product_id");
        dispatch(product_details(id));
        dispatch(product_reviews(id));

      }, [dispatch, loadingPostReviews]);
    

    const [showShareButtons, setShowShareButtons] = useState(false);
    const toggleShareButtons = () => {
        setShowShareButtons(!showShareButtons);
    };



  const currentUrl = `${window.location.origin}/Product?id=${product?.id}`; // الرابط مع إضافة id
  const copyToClipboard = () => {
    navigator.clipboard
    .writeText(currentUrl)
    .then(() => {
    })
    .catch((err) => {
      console.error("فشل في النسخ:", err);
    });
  };

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const productId = params.get('id');

    if (productId) {
      dispatch(product_details({ id: productId }));
      localStorage.setItem("Product_id", productId);
    } else {
      console.log("No brand id found in URL");
    }
  }, [location.search, dispatch]);

    const show_searsh = useSelector(state => state?.products?.searsh);
    const [showPopup, setShowPopup] = useState(false);
    const [comment, setComment] = useState("");
    const [image, setImage] = useState(null);
    const [comments, setComments] = useState(product_review?.data?.data?.comments || []);
    const handleOpenPopup = () => setShowPopup(true);
    const handleClosePopup = () => setShowPopup(false);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
        }
    };

    const handleCommentSubmit = () => {
        // التحقق من النص أو الصورة
        if (!comment.trim() && !image) {
            alert(t("please_add_comment_or_image"));
            return;
        }
    
        dispatch(postReviews({ product_id: product?.id, comment, image }));
    
        const newComment = {
            id: comments?.length + 1,
            comment: comment.trim(),
            image: image ? URL.createObjectURL(image) : null,
        };
    
        if (newComment.comment || newComment.image) {
            setComments([newComment, ...comments]);
        }
    
        setComment(""); 
        setImage(null);
        handleClosePopup();
    };
    
    useEffect(() => {
        if (product_review?.data?.data?.comments) {
            setComments(product_review.data.data.comments);
        }
    }, [product_review]); // تتبع تغييرات `product_review`
    


    const gotoBrand = (id) => {
        localStorage.setItem('brandId', id);
        dispatch(show_brand({ id }));
        navigate('/Brand');
        window.scrollTo(0, 0); 
      };
    
      const gotoInfluencer = (id) => {
        localStorage.setItem('InfluencerId', id);
        navigate('/Influencer');
        window.scrollTo(0, 0); 
        dispatch(show_Influencer({ id }));
    };
    
      const gotoStore = (id) => {
        localStorage.setItem('storeId', id);
        navigate('/Store');
        dispatch(show_store({ id }));
        window.scrollTo(0, 0); 
    };


    const handleNavigate = () => {
        const id = product?.type?.id;
        if (!id || !product?.vendor_type) return;

        switch (product.vendor_type) {
            case "brand":
                gotoBrand(id);
                dispatch(filter_data({influencer_id: null, brand_id: id, store_id: null}));
                dispatch(sort_data({influencer_id: null, brand_id: id, store_id: null}));
                break;
            case "influencer":
                gotoInfluencer(id);
                dispatch(filter_data({influencer_id: id, brand_id: null, store_id: null}));
                dispatch(sort_data({influencer_id: id, brand_id: null, store_id: null}));
                break;
            case "store":
                gotoStore(id);
                dispatch(filter_data({influencer_id: null, brand_id: null, store_id: id}));
                dispatch(sort_data({influencer_id: null, brand_id: null, store_id: id}));
                break;
            default:
                console.error("Unknown vendor type:", product.vendor_type);
        }
    };

    const [showPopupMessage, setshowPopupMessage] = useState(false);

    useEffect(() => {
        // if (loadingPost_cart) {
            setshowPopupMessage(true);
          const timer = setTimeout(() => {
            setshowPopupMessage(false);
          }, 3000);
      
          return () => clearTimeout(timer); 
        // }
      }, [loadingPost_cart]);


      useEffect(() => {
        const id = localStorage.getItem("InfluencerId");
        dispatch(show_Influencer({ id }));
      }, [dispatch]);
      
      useEffect(() => {
        const id = localStorage.getItem("brandId");
        dispatch(show_brand({ id }));
      }, [dispatch]);
  
      useEffect(() => {
        const id = localStorage.getItem("storeId");
        dispatch(show_store({ id }));
      }, [dispatch]);
  
      const[related_Products, setRelated_Products] = useState(null)
  
      useEffect(() => {
        if (product_detail?.data?.data?.product?.vendor_type === "store" && product_store?.data?.data) {
          setRelated_Products(product_store.data.data);
        } else if (product_detail?.data?.data?.product?.vendor_type === "influencer" && product_influencer?.data?.data) {
          setRelated_Products(product_influencer.data.data);
        } else if (product_detail?.data?.data?.product?.vendor_type === "brand" && product_brand?.data?.data) {
          setRelated_Products(product_brand.data.data);
        } else {
          setRelated_Products(null); // إذا لم يكن هناك تطابق، اجعل القيمة null
        }
      }, [product_influencer, product_store, product_brand]);

      const gotoProductDetails = (id) => {
        localStorage.setItem("Product_id", id);
    
        dispatch(product_details(id));
        dispatch(product_reviews(id));
        window.scrollTo(0, 0);
        navigate("/Product");
        dispatch(searsh_product(false));
    
      };
      const imagess1 =  related_Products?.products;

      const [startIndex1, setStartIndex1] = useState(0);
    
      const handleNext1 = () => {
        if (startIndex1 + 5 < imagess1?.length) {
          setStartIndex1(startIndex1 + 1);
        }
      };
    
      const handlePrev1 = () => {
        if (startIndex1 > 0) {
          setStartIndex1(startIndex1 - 1);
        }
      };
      const images_difalt = [
        {
          src: img2,
          title: "Photo 1",
          p: "AMERIX BIO TIN 60 PIECES",
          price: "469.000",
        },
        {
          src: img2,
          title: "Photo 2",
          p: "AMERIX BIO TIN 60 PIECES hello mohamed",
          price: "469.000",
        },
        {
          src: img3,
          title: "Photo 3",
          p: "AMERIX BIO TIN 60 PIECES",
          price: "469.000",
        },
        {
          src: img4,
          title: "Photo 4",
          p: "AMERIX BIO TIN 60 PIECES",
          price: "469.000",
        },
        {
          src: img5,
          title: "Photo 5",
          p: "AMERIX BIO TIN 60 PIECES",
          price: "469.000",
        },
        {
          src: img6,
          title: "Photo 6",
          p: "AMERIX BIO TIN 60 PIECES",
          price: "469.000",
        },
        {
          src: img6,
          title: "Photo 6",
          p: "AMERIX BIO TIN 60 PIECES",
          price: "469.000",
        },
      ];
    
      const getVisibleCountProduct = () => {
        if (window.innerWidth >= 1400) return 5; // شاشات XL
        if (window.innerWidth >= 1200) return 5; // شاشات LG
        if (window.innerWidth >= 992) return 4; // شاشات MD
        if (window.innerWidth >= 768) return 3; // شاشات SM
        if (window.innerWidth >= 576) return 3; // شاشات SM
        return 2;
      };
    
    
      const [startIndex8, setStartIndex8] = useState(0);
      const getVisibleImages8 = () => {
        return images_difalt?.slice(startIndex8, startIndex8 + getVisibleCountProduct());
      };
    
     const getVisibleImages1 = () => {
        return imagess1?.slice(startIndex1, startIndex1 + getVisibleCountProduct());
      };

      
      const menuRef = useRef(null);
      const shareRef = useRef(null);


      const handleClickOutside = (event) => {
          if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowRating(false); 
          }
          if (shareRef.current && !shareRef.current.contains(event.target)) {
          setShowShareButtons(!showShareButtons);
    }
      };
  
      useEffect(() => {
          if (showRating || showShareButtons) {
              document.addEventListener("mousedown", handleClickOutside);
          } else {
              document.removeEventListener("mousedown", handleClickOutside);
          }
  
          return () => {
              document.removeEventListener("mousedown", handleClickOutside);
          };
      }, [showRating, showShareButtons]);
    
    return (
        <div className="Product">
            <Header />
            {showR && (
        <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

            {show_searsh &&
                <Searsh />
            }

            {loadingPost_cart && <Loader />}
            {loadingPostReviews && <Loader />}
            {loadingProduct_details && <Loader />}
            <div className={`container_Product container`}>
            <div className='row justify-content-between mt-5 mm g-0'>
                <div className="box_image col-12 col-md-5 col-lg-5">
                    <div className='main_img'>
                        <img 
                            src={selectedItem || product_detail?.data?.data?.product?.main_image} 
                            alt='imag'
                        />
                        <i
                            className='i'
                            onClick={(event) => {
                                handelAdd_wishlist(product.id, event);
                                event.stopPropagation();
                              }}                            style={{ color: favorite?.some(item => item.product_id === product?.id) ? 'red' : 'white' }} 
                        >
                            <FontAwesomeIcon icon={faHeart} />
                        </i>
                    </div>
                    <div className="div_counter">
                    <PerfectScrollbar style={{ Width: "100%", maxHeight: "150px", overflowX: "auto", overflowY: "hidden" }}>

                        <div className="div_images">
                            {product?.images?.length > 0 && product.images.map((image, index) => (
                                <img 
                                    src={image?.image} 
                                    key={index} 
                                    className={activ === index ? 'activ' : ''} 
                                    onClick={() => handelImgeClik(image?.image, index)} 
                                    alt={index}
                                />
                            ))}
                        </div>
                    </PerfectScrollbar>
                    </div> 
                </div>
                
                <div className="box_data col-12 col-md-5 col-lg-4">
                    <p>{product?.name}</p>
                    <p>{product?.description}</p>
                    <p className='price'>{product?.new_price} KD <span>{product?.old_price} KD</span></p>
                    <div className='check'>
                        <i className='i'><FontAwesomeIcon icon={faCheck} /></i>
                        <p>{product?.status}</p>
                    </div>
                    

                    <div className='Color'>
                    <p>{t("color")}</p>
                    <PerfectScrollbar style={{ Width: "100%", maxHeight: "150px", overflowX: "auto", overflowY: "hidden" }}>

                        <div className='imgs'>
                        {product?.colors?.map((color, index) => (
                            <img 
                            src={color?.image} 
                            key={index} 
                            className={selectedColor === color?.id ? 'selected' : ''} 
                            onClick={() => toggleColorSelection(color?.id)} 
                            alt={index}
                            />
                        ))}
                        </div>
                        </PerfectScrollbar>

                    </div>


                    <div className='Size'>
                    <p>{t("size")}</p>
                    <PerfectScrollbar style={{ Width: "100%", maxHeight: "150px", overflowX: "auto", overflowY: "hidden" }}>
                        <div>
                        {product?.sizes?.map((size, index) => (
                            <p 
                            key={index} 
                            className={selectedSize === size?.id ? 'selected' : ''} 
                            onClick={() => toggleSizeSelection(size?.id)} 
                            >
                            {size?.size}
                            </p>
                        ))}
                        </div>
                    </PerfectScrollbar>
                    </div>


                    
                    <div className='Quantity'>
                    <p>{t("quantity")}</p>
                    <div className="counter">
                            <span className='span1' onClick={decrement}>-</span>
                            <span className='span3'>{counter}</span>
                            <span className='span2' onClick={increment}>+</span>
                        </div>
                    </div>

                    {errorMessage && <p className="error-message mt-2 mb-0 p-0">{errorMessage}</p>}
                    <div className='add'>
                    <p className={counter > 0 ? 'active' : ''} onClick={handleAddToBasket}>{t("addToBasket")}</p>
                    <p className={counter > 0 ? 'active' : ''} onClick={gotoBuyNow}>{t("buyNow")}</p>
                    </div>
                </div>

                <div className='box_brand col-12 col-lg-2 mt-md-5 mt-sm-4 d-flex justify-content-between' ref={shareRef}>
                    <div>
                    <i className='i' onClick={() => {
                        toggleShareButtons();
                        copyToClipboard();
                    }}>
                            <FontAwesomeIcon icon={faShare} />
                        </i>

                        {showShareButtons && (
                        <div className="share-buttons" onClick={toggleShareButtons}>
                <FacebookShareButton url={currentUrl}>
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton url={currentUrl}>
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
                <WhatsappShareButton url={currentUrl}>
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <LinkedinShareButton url={currentUrl}>
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>
                <PinterestShareButton url={currentUrl}>
                  <PinterestIcon size={32} round />
                </PinterestShareButton>
                <TelegramShareButton url={currentUrl}>
                  <TelegramIcon size={32} round />
                </TelegramShareButton>
                </div>
                        )}

                    </div>
                    <div className='col-5 col-lg-12'>
                    <p onClick={handleNavigate}>{product?.vendor_type} : {product?.type?.name}</p>
                    </div>
                </div>
            </div>

            </div>
            <div className={`container_data container`}>
                <div className='row justify-content-between g-0'>
                    <div className='details col-12 col-lg-5'>
                    <p className="detailsP">{t("productDetails")}</p>
                    <p className="detailsP">{t("material")}</p>
                        <p className='detailsP2'>
                        <span>{t("material")}</span>
                            <span>{product?.product_varients?.[0]?.material}</span>
                        </p>
                        <p className='detailsP2'>
                            <span>{t("materialComposition")}</span>
                            <span>{product?.product_varients?.[0]?.material_composition}</span>
                        </p>
                        <p className='detailsP'>{t("warrantyAndCare")}</p>
                        <p className='detailsP2'>
                            <span> {t("careInstructions")}</span>
                            <span>{product?.product_varients?.[0]?.care_instructions}</span>
                        </p>
                        <p className='detailsP'> {t("generalSpecifications")}</p>
                        <p className='detailsP2'>
                            <span> {t("naturesComfort")}</span>
                            <span>{product?.product_varients?.[0]?.nature_comfort}</span>
                        </p>
                        <p className='detailsP2'>
                            <span>{t("occasion")}</span>
                            <span>{product?.product_varients?.[0]?.occasion}</span>
                        </p>
                        <p className='detailsP2'>
                            <span>{t("model")}</span>
                            <span>{product?.product_varients?.[0]?.model}</span>
                        </p>
                    </div>
                    <div className='Shipping_Reviews col-12 col-lg-6'>
                        <div className='Shipping'>
                            <p className='ShippingP'>{t("shipping")}</p>
                            {product?.shippings?.length > 0 && product.shippings.map((shipping, index) => (
                                <p className='ShippingP' key={index}>
                                    <i className='i'><FontAwesomeIcon icon={faTruck} /></i>
                                    {shipping?.key}: <span>{shipping?.value}</span>
                                </p>
                            ))}
                        </div>
                        <div className='Reviews'>
                        <p className="pr">{t("reviews")}</p>
                        {loadingProduct_reviews && <Loader />}
                            {loadingPostReviews && <Loader />}
                            <div className='ReviewsD justify-content-between align-items-center'>
                                <div>
                                    <p>{t("averageRating")}</p>
                                    <p className='p5'>{rating}</p>
                                    <p>{t('outOf')}</p>
                                    </div>
                                <div className="star-container" onClick={FshowRating}>
                                    {[
                                        { stars: 5, count: ratings?.five_star },
                                        { stars: 4, count: ratings?.four_star },
                                        { stars: 3, count: ratings?.three_star },
                                        { stars: 2, count: ratings?.two_star },
                                        { stars: 1, count: ratings?.one_star },
                                    ].map((ratingItem, index) => (
                                        <div
                                            key={index}
                                            className={`star-row ${rating === ratingItem?.stars ? 'highlight-stars' : ''}`}
                                        >
                                            <div className="stars">
                                                {Array.from({ length: ratingItem?.stars }).map((_, i) => (
                                                    <FontAwesomeIcon key={i} icon={faStar} className='mx-1' />
                                                ))}
                                            </div>
                                            <div className="line"></div>
                                            <span className="star-count">{ratingItem?.count || 0}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className='button mt-4'>
                            <p className="button1">{t("what_do_you_think")}</p>
                        <p className="button2" onClick={handleOpenPopup}>{t("writeReview")}</p>

                            </div>
                            {showRating && (
  <div className="star-ratings-popup" ref={menuRef}>
        <h3 className="popup-title">{t('rateThis')}</h3>
        <div className="stars-container">
      <StarRatings
        rating={rat}
        starRatedColor="gold"
        changeRating={changeRating}
        numberOfStars={5}
        name="rating"
        starDimension="30px"
        starSpacing="5px"
      />
    </div>
    <button className="close-popup-btn" onClick={() => setShowRating(false)}>
    {t('close')}
    </button>
  </div>
)}
{showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <button className="close-button" onClick={handleClosePopup}>
                            X
                        </button>
                        <h4>{t("productComments")}</h4>

                        <div className="comments-section">
                        <PerfectScrollbar style={{ maxHeight: '220px', overflow: 'hidden' }}>
                        {comments?.length > 0 ? (
                                comments.filter(cmt => cmt.comment || cmt.image).map((cmt, index) => (

                                <div key={index} className="comment-item">
                                    <div className="user-info">
                                        <img
                                            src={cmt?.user?.user_image || "default-avatar.png"} // صورة المستخدم أو صورة افتراضية
                                            alt={`${cmt.username}'s avatar`}
                                            className="user-avatar"
                                        />
                                        <p className="user-name">{cmt.user.name || "Anonymous"}</p>
                                    </div>
                                    <div className="comment-content">
                                        <p className="comment-text">{cmt.comment}</p>
                                        {cmt.image && (
                                            <img
                                                src={cmt.image}
                                                alt="attached"
                                                className="comment-image"
                                            />
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                          <>
                            <div className="empty-cart">
                              <img src={no_comment} alt="Empty Cart" />
                            </div>
                              <p className="no-comments">{t("no_comments_yet")}</p>
                            </>
                        )}

                        </PerfectScrollbar>

                        </div>

                        <div className="add-comment-section">
                            <div className="image-preview">
                            {image ? (
                                <img src={URL.createObjectURL(image)} alt="Preview" />
                                ) : (
                                    <div className="placeholder">uploadImage</div>
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    className="image-input"
                                />
                            </div>

                            <textarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder={t("commentPlaceholder")}
                            ></textarea>
                        </div>

                        <button onClick={handleCommentSubmit} className="submit-button">
                            {t("submit")}
                        </button>
                    </div>
                </div>
            )}


                        </div>
                    </div>
                </div>
                <div className='Customer'><span>{Object.values(product_review?.data?.data?.ratings || {}).reduce((total, count) => total + (count || 0), 0)}
                </span>   {t('customer_reviews')} 
                <span> {comments.filter(cmt => cmt.comment || cmt.image)?.length}</span> {t('customer_ratings')} </div>
            </div>
            {showPopupMessage && (
                <>
                    {Post_carts?.data?.message &&
                        <div className="popup-message">
                            {Post_carts?.data?.message && <FontAwesomeIcon icon={faCheck} className='icon_message' />}
                            <span>{Post_carts?.data?.message}</span>
                        </div>
                    }
                </>
            )}








<div className="container">
        <p>{t('relatedProducts')}</p>
      </div>

<div className="gallery1 container">

        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconLeft" onClick={handlePrev1} />
        </div>
        <div className="row align-items-center justify-content-between g-0">
        {(getVisibleImages1()?.length > 0
            ? getVisibleImages1()
            : getVisibleImages8()
          ).map((product, index) => {
            const isInWishlist = favorite?.some(
              (item) => item.product_id === product.id
            ); 

            return (
              <div
                className="box col-6 px-3 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 col-xl-2 px-xl-0 mx-xl-0 text-center"
                key={index}
              >
                <div className="border_box">
                    <div className="padding_box"onClick={() => gotoProductDetails(product.id)} >
                    <i
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="ده التولتيب بتاعي"
                      onClick={(event) => {
                        handelAdd_wishlist(product.id, event);
                        event.stopPropagation();

                      }}
                      style={{ color: isInWishlist ? "red" : "white" }}
                    >
                      <FontAwesomeIcon icon={faHeart} />
                    </i>
                    {product?.discount && (
                      <p className="discount">Off {product?.discount}</p>
                    )}
                    {product?.main_image && (
                      <img
                        src={product?.main_image}
                        alt={`img-${index}`}
                      />
                    )}
                    <p className="discraptoin">{product?.description}</p>
                    <div className="price align-items-center">
                      <p>{product?.new_price}</p>
                      {product?.old_price && (
                        <p className="old_price">{product?.old_price}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-1 text-center icon2">
          <img src={icon9} className="iconRitgh" onClick={handleNext1} />
        </div>
      </div>







            <Footer Sign_Up={Sign_Up} />
        </div>
    );
}

export default Product;
